import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6baf2c5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "subheader d-block d-md-flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "subheader-title mb-2 mb-md-0" }, "データポータル", -1))
const _hoisted_4 = { class: "d-block d-md-flex mr-0 justify-content-md-end" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<option value=\"2023\" data-v-6baf2c5a>2023年度</option><option value=\"2024\" data-v-6baf2c5a>2024年度</option><option value=\"2025\" data-v-6baf2c5a>2025年度</option><option value=\"2026\" data-v-6baf2c5a>2026年度</option><option value=\"2027\" data-v-6baf2c5a>2027年度</option><option value=\"2028\" data-v-6baf2c5a>2028年度</option><option value=\"2029\" data-v-6baf2c5a>2029年度</option>", 7)
const _hoisted_13 = [
  _hoisted_6
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "vr mr-2 mb-2 align-self-center" }, null, -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "row d-flex mr-0 justify-content-end" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-2 mb-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "peity",
    height: "40",
    width: "40"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M 20 0 A 20 20 0 0 1 39.02113032590307 26.18033988749895 L 33.31479122813215 24.326237921249263 A 14 14 0 0 0 20 6",
      "data-value": "1",
      fill: "#2196F3"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M 39.02113032590307 26.18033988749895 A 20 20 0 1 1 19.999999999999996 0 L 19.999999999999996 6 A 14 14 0 1 0 33.31479122813215 24.326237921249263",
      "data-value": "9",
      fill: "#9acffa"
    })
  ])
], -1))
const _hoisted_19 = { class: "mr-2 mb-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-sm mb-0 mt-2 mt-md-0" }, "当期受注利益率", -1))
const _hoisted_21 = { class: "font-weight-bold mb-0" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-sm-6 col-xl-3" }
const _hoisted_24 = { class: "p-3 bg-primary-300 rounded overflow-hidden position-relative text-white mb-g" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "display-4 d-block l-h-n m-0 fw-500" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "col-6 m-0 l-h-n" }, "当期受注売上額", -1))
const _hoisted_29 = { class: "col-6 m-0 l-h-n mt-1 text-right" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-yen-sign position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1",
  style: {"font-size":"6rem"}
}, null, -1))
const _hoisted_31 = { class: "col-sm-6 col-xl-3" }
const _hoisted_32 = { class: "p-3 bg-warning-400 rounded overflow-hidden position-relative text-white mb-g" }
const _hoisted_33 = { class: "" }
const _hoisted_34 = { class: "display-4 d-block l-h-n m-0 fw-500" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "col-6 m-0 l-h-n" }, "当期受注粗利額", -1))
const _hoisted_37 = { class: "col-6 m-0 l-h-n mt-1 text-right" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-gem position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n4",
  style: {"font-size":"6rem"}
}, null, -1))
const _hoisted_39 = { class: "col-sm-6 col-xl-3" }
const _hoisted_40 = { class: "p-3 bg-success-200 rounded overflow-hidden position-relative text-white mb-g" }
const _hoisted_41 = { class: "" }
const _hoisted_42 = { class: "display-4 d-block l-h-n m-0 fw-500" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "m-0 l-h-n" }, "当期売上目標充足率", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-lightbulb position-absolute pos-right pos-bottom opacity-15 mb-n5 mr-n6",
  style: {"font-size":"8rem"}
}, null, -1))
const _hoisted_45 = { class: "col-sm-6 col-xl-3" }
const _hoisted_46 = { class: "p-3 bg-info-200 rounded overflow-hidden position-relative text-white mb-g" }
const _hoisted_47 = { class: "" }
const _hoisted_48 = { class: "display-4 d-block l-h-n m-0 fw-500" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "m-0 l-h-n" }, "当期粗利目標充足率", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-globe position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n4",
  style: {"font-size":"6rem"}
}, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  role: "tablist",
  style: {"margin-bottom":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link fs-xl py-3 px-5 active",
      "data-toggle": "tab",
      href: "#tab_1_home",
      role: "tab",
      "aria-selected": "true"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fal fa-chart-line text-success" }),
      /*#__PURE__*/_createElementVNode("span", { class: "hidden-sm-down ml-1" }, "全体")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link fs-xl py-3 px-5",
      "data-toggle": "tab",
      href: "#tab_2_uriage",
      role: "tab",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fal fa-coins text-primary" }),
      /*#__PURE__*/_createElementVNode("span", { class: "hidden-sm-down ml-1" }, "売上先")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link fs-xl py-3 px-5",
      "data-toggle": "tab",
      href: "#tab_3_koukokusi",
      role: "tab",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fal fa-pennant text-primary" }),
      /*#__PURE__*/_createElementVNode("span", { class: "hidden-sm-down ml-1" }, "広告主")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link fs-xl py-3 px-5",
      "data-toggle": "tab",
      href: "#tab_4_siiresaki",
      role: "tab",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fal fa-parachute-box text-primary" }),
      /*#__PURE__*/_createElementVNode("span", { class: "hidden-sm-down ml-1" }, "仕入先")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link fs-xl py-3 px-5",
      "data-toggle": "tab",
      href: "#tab_5_media",
      role: "tab",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fal fa-photo-video text-primary" }),
      /*#__PURE__*/_createElementVNode("span", { class: "hidden-sm-down ml-1" }, "メディア")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link fs-xl py-3 px-5",
      "data-toggle": "tab",
      href: "#tab_6_eigyotanto",
      role: "tab",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user text-danger" }),
      /*#__PURE__*/_createElementVNode("span", { class: "hidden-sm-down ml-1" }, "営業担当")
    ])
  ])
], -1))
const _hoisted_52 = { class: "tab-content p-3" }
const _hoisted_53 = {
  class: "tab-pane active",
  id: "tab_1_home",
  role: "tabpanel"
}
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-xl-12" }
const _hoisted_56 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "売上詳細"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_58 = {
  class: "panel-container show",
  id: "panel-100_summary-graph"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_60 = { class: "panel-content contents" }
const _hoisted_61 = { style: {"max-height":"500px"} }
const _hoisted_62 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-6baf2c5a><div class=\"col-xl-12\" data-v-6baf2c5a><div id=\"panel-1\" class=\"panel\" data-v-6baf2c5a><div class=\"panel-hdr\" data-v-6baf2c5a><h2 data-v-6baf2c5a>商品種別累計売上</h2><div class=\"panel-toolbar\" data-v-6baf2c5a><button class=\"btn btn-panel\" data-action=\"panel-collapse\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Collapse\" data-v-6baf2c5a></button><button class=\"btn btn-panel\" data-action=\"panel-fullscreen\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Fullscreen\" data-v-6baf2c5a></button></div></div><div class=\"panel-container show\" data-v-6baf2c5a><div class=\"panel-content contents\" data-v-6baf2c5a><div class=\"tentative\" style=\"height:500px;\" data-v-6baf2c5a> 月別利益率の折れ線グラフ </div></div></div></div></div></div><div class=\"row\" data-v-6baf2c5a><div class=\"col-lg-5\" data-v-6baf2c5a><div id=\"panel-1\" class=\"panel\" data-v-6baf2c5a><div class=\"panel-hdr\" data-v-6baf2c5a><h2 data-v-6baf2c5a>構成割合</h2><div class=\"panel-toolbar\" data-v-6baf2c5a><button class=\"btn btn-panel\" data-action=\"panel-collapse\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Collapse\" data-v-6baf2c5a></button><button class=\"btn btn-panel\" data-action=\"panel-fullscreen\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Fullscreen\" data-v-6baf2c5a></button></div></div><div class=\"panel-container show\" data-v-6baf2c5a><div class=\"panel-content border-faded border-left-0 border-right-0 border-top-0 text-muted d-flex\" data-v-6baf2c5a><div class=\"tentative\" style=\"height:250px;\" data-v-6baf2c5a> 顧客別売上別円グラフ </div></div><div class=\"panel-content contents\" data-v-6baf2c5a><div class=\"tentative\" style=\"height:250px;\" data-v-6baf2c5a> 商品別売上別円グラフ </div></div></div></div></div><div class=\"col-lg-7\" data-v-6baf2c5a><div id=\"panel-1\" class=\"panel\" data-v-6baf2c5a><div class=\"panel-hdr\" data-v-6baf2c5a><h2 data-v-6baf2c5a>エリア別商品分布</h2><div class=\"panel-toolbar\" data-v-6baf2c5a><button class=\"btn btn-panel\" data-action=\"panel-collapse\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Collapse\" data-v-6baf2c5a></button><button class=\"btn btn-panel\" data-action=\"panel-fullscreen\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Fullscreen\" data-v-6baf2c5a></button></div></div><div class=\"panel-container show\" data-v-6baf2c5a><div class=\"tentative\" style=\"height:570px;\" data-v-6baf2c5a> 担当者別の情報の一覧（内容未定） </div></div></div></div></div>", 2)
const _hoisted_64 = { class: "row" }
const _hoisted_65 = { class: "col-xl-12" }
const _hoisted_66 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "集計対象情報一覧"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_68 = { class: "panel-container show panel-200_summary-list" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_70 = { class: "panel-content" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col contCnt" }
const _hoisted_73 = {
  class: "demo",
  style: {"overflow":"auto","max-height":"500px"}
}
const _hoisted_74 = {
  class: "table table-sm table-bordered m-0 tableList",
  style: {"margin":"0 !important"}
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-primary-400" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSL200 slh_1" }, "日付"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSL200 slh_2" }, "売上先名"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSL200 slh_3" }, "売上"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSL200 slh_4" }, "仕入"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSL200 slh_5" }, "利益"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSL200 slh_6" }, "利益率")
  ])
], -1))
const _hoisted_76 = { class: "rowSL200 slh_1" }
const _hoisted_77 = { class: "rowSL200 slh_2" }
const _hoisted_78 = { class: "rowSL200 slh_3" }
const _hoisted_79 = { class: "rowSL200 slh_4" }
const _hoisted_80 = { class: "rowSL200 slh_5" }
const _hoisted_81 = { class: "rowSL200 slh_6" }
const _hoisted_82 = {
  class: "tab-pane",
  id: "tab_2_uriage",
  role: "tabpanel"
}
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-xl-12" }
const _hoisted_85 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "分析条件"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_87 = {
  class: "panel-container show",
  id: "panel-x_client-search"
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_89 = { class: "panel-content contents" }
const _hoisted_90 = { class: "row" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "売上先", -1))
const _hoisted_92 = { class: "col-md-5 contCnt" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "業種", -1))
const _hoisted_94 = { class: "col-md-5 contCnt" }
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "col-md-12 contCnt text-center" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 contCnt text-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("small", null, " 指定条件によって分析には時間がかかる場合があります ")
  ])
], -1))
const _hoisted_98 = { class: "row" }
const _hoisted_99 = { class: "col-xl-12" }
const _hoisted_100 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "顧客別売上"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_102 = {
  class: "panel-container show",
  id: "panel-300_client-graph"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_104 = { class: "panel-content contents" }
const _hoisted_105 = { class: "row" }
const _hoisted_106 = { class: "col-lg-6" }
const _hoisted_107 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "業種別受注売上額"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_109 = {
  class: "panel-container show",
  id: "panel-400_genre-graph"
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_111 = { class: "panel-content contents" }
const _hoisted_112 = { class: "col-lg-6" }
const _hoisted_113 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "顧客別受注売上一覧"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_115 = {
  class: "panel-container show",
  id: "panel-500_rank-list"
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_117 = { class: "panel-content" }
const _hoisted_118 = { class: "row" }
const _hoisted_119 = { class: "col contCnt" }
const _hoisted_120 = {
  class: "demo",
  style: {"overflow":"auto","max-height":"730px"}
}
const _hoisted_121 = {
  class: "table table-sm table-bordered m-0 tableList",
  style: {"margin":"0 !important"}
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-primary-400" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headRL500 rlh_1" }, "順位"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headRL500 rlh_2" }, "顧客名"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headRL500 rlh_3" }, "受注売上"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headRL500 rlh_4" }, "受注仕入"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headRL500 rlh_5" }, "受注利益"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headRL500 rlh_6" }, " 受注利益率 ")
  ])
], -1))
const _hoisted_123 = { class: "rowRL500 rlh_1" }
const _hoisted_124 = { class: "rowRL500 rlh_2" }
const _hoisted_125 = { class: "rowRL500 rlh_3" }
const _hoisted_126 = { class: "rowRL500 rlh_4" }
const _hoisted_127 = { class: "rowRL500 rlh_5" }
const _hoisted_128 = { class: "rowRL500 rlh_6" }
const _hoisted_129 = { class: "row" }
const _hoisted_130 = { class: "col-xl-12" }
const _hoisted_131 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "集計対象情報一覧"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_133 = { class: "panel-container show panel-200_summary-list" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_135 = { class: "panel-content" }
const _hoisted_136 = { class: "row" }
const _hoisted_137 = { class: "col contCnt" }
const _hoisted_138 = {
  class: "demo",
  style: {"overflow":"auto","max-height":"500px"}
}
const _hoisted_139 = {
  class: "table table-sm table-bordered m-0 tableList",
  style: {"margin":"0 !important"}
}
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-primary-400" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSL200 slh_1" }, "日付"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSL200 slh_2" }, "売上先名"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSL200 slh_3" }, "売上"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSL200 slh_4" }, "仕入"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSL200 slh_5" }, "利益"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSL200 slh_6" }, "利益率")
  ])
], -1))
const _hoisted_141 = { class: "rowSL200 slh_1" }
const _hoisted_142 = { class: "rowSL200 slh_2" }
const _hoisted_143 = { class: "rowSL200 slh_3" }
const _hoisted_144 = { class: "rowSL200 slh_4" }
const _hoisted_145 = { class: "rowSL200 slh_5" }
const _hoisted_146 = { class: "rowSL200 slh_6" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane",
  id: "tab_3_koukokusi",
  role: "tabpanel"
}, null, -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane",
  id: "tab_4_siiresaki",
  role: "tabpanel"
}, null, -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane",
  id: "tab_5_media",
  role: "tabpanel"
}, null, -1))
const _hoisted_150 = {
  class: "tab-pane",
  id: "tab_6_eigyotanto",
  role: "tabpanel"
}
const _hoisted_151 = {
  class: "row enable-loader",
  id: "panel-1900_staff-list",
  style: {"position":"relative"}
}
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_153 = {
  class: "card border shadow-0 mb-g shadow-sm-hover",
  "data-filter-tags": "oliver kopyov"
}
const _hoisted_154 = { class: "card-body border-faded border-top-0 border-left-0 border-right-0 rounded-top" }
const _hoisted_155 = { class: "d-flex flex-row align-items-center" }
const _hoisted_156 = { class: "info-card-text flex-1" }
const _hoisted_157 = ["onClick"]
const _hoisted_158 = { class: "text-truncate text-truncate-xl" }
const _hoisted_159 = { class: "card-body p-0 collapse show" }
const _hoisted_160 = { class: "p-3" }
const _hoisted_161 = { class: "row" }
const _hoisted_162 = { class: "col-6" }
const _hoisted_163 = { class: "cardrow clearfix" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cardRowHead cardRowHead1" }, "受注売上額：", -1))
const _hoisted_165 = { class: "cardRowCont cardRowCont1" }
const _hoisted_166 = { class: "col-6" }
const _hoisted_167 = { class: "cardrow clearfix" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cardRowHead cardRowHead1" }, "受注仕入額：", -1))
const _hoisted_169 = { class: "cardRowCont cardRowCont1" }
const _hoisted_170 = { class: "row" }
const _hoisted_171 = { class: "col-6" }
const _hoisted_172 = { class: "cardrow clearfix" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cardRowHead cardRowHead1" }, "受注利益額：", -1))
const _hoisted_174 = { class: "cardRowCont cardRowCont1" }
const _hoisted_175 = { class: "col-6" }
const _hoisted_176 = { class: "cardrow clearfix" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cardRowHead cardRowHead1" }, "受注利益率：", -1))
const _hoisted_178 = { class: "cardRowCont cardRowCont1" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_181 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mo_chart_barline = _resolveComponent("Mo_chart_barline")!
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            class: "mr-2",
            style: {"border":"1px solid #ddd","height":"40px","border-radius":"5px","min-width":"100px","text-align":"center"},
            disabled: _ctx.btnDisable,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.domBisYear) = $event))
          }, _hoisted_13, 8, _hoisted_5), [
            [_vModelSelect, _ctx.domBisYear]
          ]),
          _hoisted_14,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success waves-effect waves-themed mr-2 mb-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.get4All())),
            disabled: _ctx.btnDisable
          }, " 再読み込み ", 8, _hoisted_15),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success waves-effect waves-themed mr-2 mb-2",
            disabled: _ctx.btnDisable
          }, " レポート出力 ", 8, _hoisted_16)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("h4", _hoisted_21, _toDisplayString(_ctx.delegate.Badge_0_5_profitRatio) + "% ", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("h3", _hoisted_26, [
                _createTextVNode(" ¥" + _toDisplayString(_ctx.delegate.Badge_0_1_sales.toLocaleString("ja-JP")) + "- ", 1),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("small", _hoisted_29, "¥" + _toDisplayString(_ctx.delegate.Badge_0_6_earnings.toLocaleString("ja-JP")) + "-", 1)
                ])
              ])
            ]),
            _hoisted_30
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("h3", _hoisted_34, [
                _createTextVNode(" ¥" + _toDisplayString(_ctx.delegate.Badge_0_2_profit.toLocaleString("ja-JP")) + "- ", 1),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("small", _hoisted_37, "¥" + _toDisplayString(_ctx.delegate.Badge_0_7_gross.toLocaleString("ja-JP")) + "-", 1)
                ])
              ])
            ]),
            _hoisted_38
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("h3", _hoisted_42, [
                _createTextVNode(_toDisplayString(_ctx.delegate.Badge_0_3_gale2salseRatio) + "% ", 1),
                _hoisted_43
              ])
            ]),
            _hoisted_44
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("h3", _hoisted_48, [
                _createTextVNode(_toDisplayString(_ctx.delegate.Badge_0_4_gale2profitRatio) + "% ", 1),
                _hoisted_49
              ])
            ]),
            _hoisted_50
          ])
        ])
      ]),
      _hoisted_51,
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      (_ctx.reRender)
                        ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                            key: 0,
                            chartData: _ctx.delegate.summary_graph_100_chartData,
                            options: _ctx.chartOptions4SalesGraph100
                          }, null, 8, ["chartData", "options"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_62,
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _hoisted_67,
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("table", _hoisted_74, [
                            _hoisted_75,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delegate.summary_list_200_listData, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: item.c_agg_client_id!
                                }, [
                                  _createElementVNode("td", _hoisted_76, _toDisplayString(item.c_agg_client_year) + "年 " + _toDisplayString(item.c_agg_client_month) + "月 ", 1),
                                  _createElementVNode("td", _hoisted_77, _toDisplayString(item.c_client_name), 1),
                                  _createElementVNode("td", _hoisted_78, _toDisplayString(item.c_agg_client_amount_sales!.toLocaleString(
                                    "ja-JP"
                                  )), 1),
                                  _createElementVNode("td", _hoisted_79, _toDisplayString(item.c_agg_client_amount_supply!.toLocaleString(
                                    "ja-JP"
                                  )), 1),
                                  _createElementVNode("td", _hoisted_80, _toDisplayString(item.c_agg_client_amount_profit!.toLocaleString(
                                    "ja-JP"
                                  )), 1),
                                  _createElementVNode("td", _hoisted_81, _toDisplayString(item.c_agg_client_ratio_profit) + "% ", 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_82, [
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _hoisted_86,
                _createElementVNode("div", _hoisted_87, [
                  _hoisted_88,
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      _hoisted_91,
                      _createElementVNode("div", _hoisted_92, [
                        _createVNode(_component_vSelect, {
                          multiple: "",
                          options: _ctx.optionsOp,
                          disabled: ""
                        }, null, 8, ["options"])
                      ]),
                      _hoisted_93,
                      _createElementVNode("div", _hoisted_94, [
                        _createVNode(_component_vSelect, {
                          multiple: "",
                          options: _ctx.optionsOp4,
                          disabled: ""
                        }, null, 8, ["options"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary waves-effect waves-themed btn-search mx-auto",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.analy4Client())),
                          disabled: ""
                        }, " 分析開始 ")
                      ]),
                      _hoisted_97
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("div", _hoisted_100, [
                _hoisted_101,
                _createElementVNode("div", _hoisted_102, [
                  _hoisted_103,
                  _createElementVNode("div", _hoisted_104, [
                    (_ctx.reRender)
                      ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                          key: 0,
                          class: "chart300",
                          chartData: _ctx.delegate.client_graph_300_chartData_now,
                          options: _ctx.chartOptions4ClientGraph300
                        }, null, 8, ["chartData", "options"]))
                      : _createCommentVNode("", true),
                    (_ctx.reRender)
                      ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                          key: 1,
                          class: "chart300",
                          chartData: _ctx.delegate.client_graph_300_chartData_now4Suupy,
                          options: _ctx.chartOptions4ClientGraph300
                        }, null, 8, ["chartData", "options"]))
                      : _createCommentVNode("", true),
                    (_ctx.reRender)
                      ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                          key: 2,
                          class: "chart300",
                          chartData: _ctx.delegate.client_graph_300_chartData_now4Profit,
                          options: _ctx.chartOptions4ClientGraph300
                        }, null, 8, ["chartData", "options"]))
                      : _createCommentVNode("", true),
                    (_ctx.reRender)
                      ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                          key: 3,
                          class: "chart300",
                          chartData: _ctx.delegate.client_graph_300_chartData_onePrev,
                          options: _ctx.chartOptions4ClientGraph300
                        }, null, 8, ["chartData", "options"]))
                      : _createCommentVNode("", true),
                    (_ctx.reRender)
                      ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                          key: 4,
                          class: "chart300",
                          chartData: 
                      _ctx.delegate.client_graph_300_chartData_onePrev4Suupy
                    ,
                          options: _ctx.chartOptions4ClientGraph300
                        }, null, 8, ["chartData", "options"]))
                      : _createCommentVNode("", true),
                    (_ctx.reRender)
                      ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                          key: 5,
                          class: "chart300",
                          chartData: 
                      _ctx.delegate.client_graph_300_chartData_onePrev4Profit
                    ,
                          options: _ctx.chartOptions4ClientGraph300
                        }, null, 8, ["chartData", "options"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_105, [
            _createElementVNode("div", _hoisted_106, [
              _createElementVNode("div", _hoisted_107, [
                _hoisted_108,
                _createElementVNode("div", _hoisted_109, [
                  _hoisted_110,
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("div", null, [
                      (_ctx.reRender)
                        ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                            key: 0,
                            class: "chart400",
                            chartData: _ctx.delegate.client_graph_400_chartData,
                            options: _ctx.chartOptions4GenreGraph400
                          }, null, 8, ["chartData", "options"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("div", _hoisted_113, [
                _hoisted_114,
                _createElementVNode("div", _hoisted_115, [
                  _hoisted_116,
                  _createElementVNode("div", _hoisted_117, [
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("div", _hoisted_120, [
                          _createElementVNode("table", _hoisted_121, [
                            _hoisted_122,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delegate.client_list_500_listData, (item, index) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: item.c_client_id!
                                }, [
                                  _createElementVNode("td", _hoisted_123, _toDisplayString(index + 1), 1),
                                  _createElementVNode("td", _hoisted_124, _toDisplayString(item.c_client_name), 1),
                                  _createElementVNode("td", _hoisted_125, _toDisplayString(item.sumSales!.toLocaleString("ja-JP")), 1),
                                  _createElementVNode("td", _hoisted_126, _toDisplayString(item.sumSupply!.toLocaleString("ja-JP")), 1),
                                  _createElementVNode("td", _hoisted_127, _toDisplayString(item.sumProfit!.toLocaleString("ja-JP")), 1),
                                  _createElementVNode("td", _hoisted_128, _toDisplayString(_ctx.cnvProfitRatio(item)) + "% ", 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_129, [
            _createElementVNode("div", _hoisted_130, [
              _createElementVNode("div", _hoisted_131, [
                _hoisted_132,
                _createElementVNode("div", _hoisted_133, [
                  _hoisted_134,
                  _createElementVNode("div", _hoisted_135, [
                    _createElementVNode("div", _hoisted_136, [
                      _createElementVNode("div", _hoisted_137, [
                        _createElementVNode("div", _hoisted_138, [
                          _createElementVNode("table", _hoisted_139, [
                            _hoisted_140,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delegate.summary_list_200_listData, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: item.c_agg_client_id!
                                }, [
                                  _createElementVNode("td", _hoisted_141, _toDisplayString(item.c_agg_client_year) + "年 " + _toDisplayString(item.c_agg_client_month) + "月 ", 1),
                                  _createElementVNode("td", _hoisted_142, _toDisplayString(item.c_client_name), 1),
                                  _createElementVNode("td", _hoisted_143, _toDisplayString(item.c_agg_client_amount_sales!.toLocaleString(
                                    "ja-JP"
                                  )), 1),
                                  _createElementVNode("td", _hoisted_144, _toDisplayString(item.c_agg_client_amount_supply!.toLocaleString(
                                    "ja-JP"
                                  )), 1),
                                  _createElementVNode("td", _hoisted_145, _toDisplayString(item.c_agg_client_amount_profit!.toLocaleString(
                                    "ja-JP"
                                  )), 1),
                                  _createElementVNode("td", _hoisted_146, _toDisplayString(item.c_agg_client_ratio_profit) + "% ", 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_147,
        _hoisted_148,
        _hoisted_149,
        _createElementVNode("div", _hoisted_150, [
          _createElementVNode("div", _hoisted_151, [
            _hoisted_152,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delegate.staff_list_1900_listData, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-lg-4",
                key: item.c_staff_id!
              }, [
                _createElementVNode("div", _hoisted_153, [
                  _createElementVNode("div", _hoisted_154, [
                    _createElementVNode("div", _hoisted_155, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["mr-3", {
                      'status-success': 0 == item.c_staff_flag_del,
                      status: 0 == item.c_staff_flag_del,
                    }])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["rounded-circle profile-image d-block", {
                        genderMan: 1 == _ctx.getColor4Staff(item.c_staff_name),
                        genderWoman: 2 == _ctx.getColor4Staff(item.c_staff_name),
                        genderNone: 0 == _ctx.getColor4Staff(item.c_staff_name),
                      }]),
                          style: {"color":"#fff","font-size":"28px","font-weight":"bold","text-align":"center","vertical-align":"middle","line-height":"50px"}
                        }, _toDisplayString(_ctx.getFirstChra(item.c_staff_name)), 3)
                      ], 2),
                      _createElementVNode("div", _hoisted_156, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.goTo4parsonal(item.c_staff_id!, $event)),
                          class: "fs-xl text-truncate text-truncate-lg text-info toPrsonal"
                        }, _toDisplayString(_ctx.getStaffName(item.c_staff_name)), 9, _hoisted_157),
                        _createElementVNode("span", _hoisted_158, _toDisplayString(item.c_staff_mail), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_159, [
                    _createElementVNode("div", _hoisted_160, [
                      _createElementVNode("div", _hoisted_161, [
                        _createElementVNode("div", _hoisted_162, [
                          _createElementVNode("div", _hoisted_163, [
                            _hoisted_164,
                            _createElementVNode("div", _hoisted_165, " ¥" + _toDisplayString(item.sumSales!.toLocaleString("ja-JP")) + "- ", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_166, [
                          _createElementVNode("div", _hoisted_167, [
                            _hoisted_168,
                            _createElementVNode("div", _hoisted_169, " ¥" + _toDisplayString(item.sumSupply!.toLocaleString("ja-JP")) + "- ", 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_170, [
                        _createElementVNode("div", _hoisted_171, [
                          _createElementVNode("div", _hoisted_172, [
                            _hoisted_173,
                            _createElementVNode("div", _hoisted_174, " ¥" + _toDisplayString(item.sumProfit!.toLocaleString("ja-JP")) + "- ", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_175, [
                          _createElementVNode("div", _hoisted_176, [
                            _hoisted_177,
                            _createElementVNode("div", _hoisted_178, _toDisplayString(item.avgRatioProfit) + "% ", 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _hoisted_179,
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_180
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_181, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}